import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconInnerFn = /* @__PURE__ */ createRecipe('radio-icon-inner', {}, [])

const radioOnlyIconInnerVariantMap = {}

const radioOnlyIconInnerVariantKeys = Object.keys(radioOnlyIconInnerVariantMap)

export const radioOnlyIconInner = /* @__PURE__ */ Object.assign(memo(radioOnlyIconInnerFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconInner',
  __getCompoundVariantCss__: radioOnlyIconInnerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconInnerVariantKeys,
  variantMap: radioOnlyIconInnerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconInnerVariantKeys)
  },
  getVariantProps: radioOnlyIconInnerFn.getVariantProps,
})